import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasTrabajoEquipoActitudAtom, puntajeTotalTrabajoEquipoActitudAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasTrabajoEnEquipoActitud = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalTrabajoEquipoActitudAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasTrabajoEquipoActitudAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasTrabajoEnEquipoActitud;
